import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hg_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("hg_token");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/signup")) {
        // allow public pages
      }
    }
    return Promise.reject(err);
  }
);

export default api;

/**
 * Download a branded PDF evidence report for an assessment (auth via interceptor).
 * Triggers a browser download. Returns true on success.
 */
export async function downloadReportPdf(assessmentId, filenameHint = "") {
  const res = await api.get(`/assessments/${assessmentId}/report.pdf`, { responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameHint || `hostguard-evidence-${assessmentId.slice(0, 8)}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
  return true;
}

/**
 * Always returns a safe STRING for display, even when FastAPI returns a 422
 * validation error (where `detail` is an array of objects) or any other shape.
 * This prevents React "Objects are not valid as a React child" crashes.
 */
export function getErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean);
    if (msgs.length) return msgs.join(". ");
  }
  if (detail && typeof detail === "object" && typeof detail.msg === "string") {
    return detail.msg;
  }
  if (typeof err?.message === "string" && err.message) return err.message;
  return fallback;
}
